import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Patient } from 'src/app/models/patient.entity';
import { AuthService } from 'src/app/services/auth.service';
import { CoreService } from 'src/app/services/core.service';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-selected-patient',
  standalone: true,
  imports: [CommonModule, MaterialModule, TablerIconsModule, TranslateModule],
  templateUrl: './selected-patient.component.html',
  styleUrl: './selected-patient.component.scss',
})
export class SelectedPatientComponent {
  patient: Patient;

  constructor(
    private patientService: PatientService,
    private router: Router,
    private settings: CoreService,
    public authService: AuthService
  ) {
    this.patientService.selectedPatient$.subscribe({
      next: (value) => {
        this.patient = value;
        console.log('patient selected', this.patient);
      },
    });
  }

  //TODO refactor with date-fns
  calcolaEta(dataNascita: string): number {
    const nascita = new Date(dataNascita);
    const oggi = new Date();
    let eta = oggi.getFullYear() - nascita.getFullYear();
    const mese = oggi.getMonth() - nascita.getMonth();
    if (mese < 0 || (mese === 0 && oggi.getDate() < nascita.getDate())) {
      eta--;
    }
    return eta;
  }

  exitPatient() {
    this.patientService.clearSelectedPatient();
    this.router.navigate(['/' + this.settings.getPortalType() + '/patients']);
  }
}
